import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  filtersList: {
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
    gap: '7%',
    margin: '0 0 5rem',
  },
  filterCard: {
    backgroundColor: colors.neutral.white,
    height: '7.2rem',
    width: `15%`,
    borderRadius: '6px',
    padding: '1.2rem 0rem 0.8rem 0rem',
    textAlign: 'center',
    color: colors.neutral[900],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& h6': {
      fontSize: '1.4rem',
    },
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  filterCardTitle: {
    font: { size: '1.2rem', lineHeight: '1.8rem', weight: 700 },
    marginTop: 0,
    marginBottom: '0.2rem',
    textTransform: 'uppercase',
  },

  filterCard_ALL: { border: `0.2rem solid ${colors.blue[600]}` },
  filterCard_GROUP: { border: `0.2rem solid ${colors.green[300]}` },
  filterCard_CUSTOM: { border: `0.2rem solid ${colors.purple[300]}` },
  filterCard_ASSOCIATION: { border: `0.2rem solid ${colors.yellow[200]}` },
  filterCard_LEVEL: { border: `0.2rem solid ${colors.yellow[200]}` },
  filterCard_INDIVIDUAL: { border: `0.2rem solid ${colors.blue[300]}` },

  filterCardActive_ALL: { backgroundColor: colors.blue[600], color: colors.neutral.white },
  filterCardActive_GROUP: { backgroundColor: colors.green[300] },
  filterCardActive_CUSTOM: { backgroundColor: colors.purple[300] },
  filterCardActive_ASSOCIATION: { backgroundColor: colors.yellow[200] },
  filterCardActive_LEVEL: { backgroundColor: colors.yellow[200] },
  filterCardActive_INDIVIDUAL: { backgroundColor: colors.blue[300] },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
